import { useCallback, useReducer } from 'react';

import { reducer } from './SuperSearchDropdownContext';

//  To TEST goto this link https://stackblitz.com/edit/react-myusedebounce?file=src%2FApp.js
const useSuperSearchDropdown = () => {
  const initial_state = {
    showDropDown: false,
    loading: false,
    data: [],
    inputValue: '',
    selectedRowNumber: 0,
    searchStatus: false,
  };
  const [state, dispatch] = useReducer(reducer, initial_state);

  const onToggleLoader = useCallback(
    (status) => {
      dispatch({ type: 'TOGGLE_LOADER', payload: status });
    },
    [dispatch],
  );
  const onToggleDropDown = useCallback(
    (status) => {
      dispatch({ type: 'TOGGLE_DROPDOWN', payload: status });
    },
    [dispatch],
  );
  const onSetData = useCallback(
    (data) => {
      dispatch({ type: 'SET_DATA', payload: data });
    },
    [dispatch],
  );
  const onSetInputValue = useCallback(
    (value) => {
      dispatch({ type: 'SET_INPUTVALUE', payload: value });
    },
    [dispatch],
  );
  const onSetSelectedRowNumber = useCallback(
    (number_) => {
      dispatch({ type: 'SET_SELECTED_ROW_NUMBER', payload: number_ });
    },
    [dispatch],
  );
  const onSetSearchStatus = useCallback(
    (status) => {
      dispatch({ type: 'SET_SEARCH_STATUS', payload: status });
    },
    [dispatch],
  );

  return {
    onToggleDropDown,
    onToggleLoader,
    onSetData,
    onSetInputValue,
    onSetSelectedRowNumber,
    onSetSearchStatus,
    state,
  };
};

export default useSuperSearchDropdown;
